import AppReducer from './AppReducer';
import CalReducer from './CalendarReducer';
import DbReducer from './DbReducer';
import ListReducer from './ListReducer';
import PageReducer from './PageReducer';
import MenuReducer from './MenuReducer';
import ChatReducer from './ChatReducer';
import CollectionsReducer from './CollectionsReducer';
import PrintReducer from './PrintReducer';

const rootReducer = {
  app: AppReducer,
  calendar: CalReducer,
  chat: ChatReducer,
  collections: CollectionsReducer,
  db: DbReducer,
  list: ListReducer,
  menu: MenuReducer,
  page: PageReducer,
  print: PrintReducer,
};

export default rootReducer;
